<template>
  <div class='list'>
    <div class="screen">
      <el-form :inline="true" size="mini" @keyup.enter.native="init()">
        <el-form-item label="类型">
          <el-select v-model="page.complaint_type_id" placeholder="请选择类型">
            <el-option label="所有" value=""></el-option>
            <el-option :label="item.name" :value="item.id" v-for="item in type" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否满意" v-if="$route.name=='公告' || $route.name=='待公布'">
          <el-select v-model="page.isSolve" placeholder="请选择是否满意">
            <el-option label="所有" value=""></el-option>
            <el-option label="满意" value="1"></el-option>
            <el-option label="不满意" value="0"></el-option>
            <el-option label="未反馈" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="page.searchbox" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="page.current=1,init()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="data"
        size="small"
        style="width: 100%">
        <el-table-column
          prop="complaint_title"
          label="标题">
        </el-table-column>
        <el-table-column
          prop="complaint_type_name"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="source"
          label="来源">
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态">
          <template slot-scope="scope">
            <el-tag :type="$store.state.suggestion.state[scope.row.state].type">{{$store.state.suggestion.state[scope.row.state].text}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间">
          <template slot-scope="scope">
            <span>{{scope.row.create_time|time}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="detail(scope.row.complaint_id)">详情</el-button>
            <el-button size="mini" type="primary" @click="open(scope.row.complaint_id)" v-if="$route.name =='待公布' && scope.row.state == 5">公布</el-button>
            <!-- <el-button size="mini" type="danger" @click="del(scope.row.complaint_id)" v-if="scope.row.state=='4'&&scope.row.is_solve&&userInfo.dd_user_id==scope.row.complainant_id&&$route.name=='我的'">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align:center">
      <el-pagination
        style="margin-top:10px"
        small
        background
        :current-page="page.current"
        :page-size="page.size"
        :total="total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper">
      </el-pagination>
    </div> 
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      screen:{},
      data:[],
      total: 0,
      page:{
        current:1,
        size:10,
        searchbox:'',
        complaint_type_id:'',
      }
    }
  },
  components: {},
  computed: {
    ...mapState({
      "type": state => state.suggestion.type,
      "userInfo": state => state.user.userInfo,
    })
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init(){
      let url='',is_handle='';
      switch(this.$route.name){
        case '公告':
          url='/complaint/publicityList';
          break;
        case '我的':
          url='/complaint/personalList';
          break;
        case '新投诉':
          url='/complaint/handleList';
          is_handle='0';
          break;
        case '已转交':
          url='/complaint/handleList';
          is_handle='1';
          break;
        case '待回复':
          url='/complaint/handleList';
          is_handle='2';
          break;
        case '待公布':
          url='/complaint/handleList';
          is_handle='3';
          break;
      }
      this.$axios.get(url,{
        params:{
          ...this.page,
          ...{
            is_handle:is_handle
          }
        }
      }).then(res=>{
        this.data=res.data.records;
        this.total=res.data.total;
      })

    },
    sizeChange(size){
      this.page.size=size;
      this.init();
    },
    currentChange(current){
      this.page.current=current;
      this.init();
    },
    detail(id){
      this.$router.push({
        name:'详情',
        query:{
          id:id,
          public:this.$route.name=='公告'?'1':'0'
        }
      })
    },
    open(id){
      this.$confirm('确定要公布此条投诉吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/complaint/publicById/'+id).then(res=>{ // TODO
          this.$message.success('公布成功！');
          this.init();
        })
      }).catch(() => {

      });
    },
    del(id){
      this.$confirm('确定删除此条投诉吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete('/complaint/'+id).then(res=>{
          this.$message.success('删除成功！');
          this.init();
        })
      }).catch(() => {

      });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>